import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

const warehouseApiUrl = "api/v1/customerwarehouse/setdefaultwarehouse";
const shipFromWarehouseApiUrl = "api/v1/customerwarehouse/setshipfromwarehouse"

interface SetShipFromWarehouseParameter extends ApiParameter {
    locationName: string,
    billTo: string,
    shipTo: string
}

export const ThosSetDefaultWarehouse = async (warehouse: WarehouseModel): Promise<ServiceResult<void>> => {
    try {
        const result = await post<WarehouseModel, void>(`${warehouseApiUrl}?locationName=${warehouse.name}`);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: "Something Went Wrong",
            };
        }
        throw error;
    }
};

export const ThosSetShipFromWarehouseForCustomer = async (warehouse: WarehouseModel, billTo?: string, shipTo?: string): Promise<ServiceResult<void>> => {
    const parameter: SetShipFromWarehouseParameter = {
        locationName: warehouse.name,
        billTo: billTo ?? "",
        shipTo: shipTo ?? ""
    }
    try {
        const result = await post<SetShipFromWarehouseParameter, void>(shipFromWarehouseApiUrl, parameter);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: "Something Went Wrong",
            };
        }
        throw error;
    }
}